import React from 'react';
import styled from 'styled-components';
import { FiInfo, FiLogOut } from 'react-icons/fi';
import demoService from '../../services/demoService';

const Pill = styled.div`
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px 8px 16px;
  border-radius: 999px;
  background: linear-gradient(90deg, #059669, #10b981);
  color: #04261b;
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);

  .msg { display: flex; align-items: center; gap: 7px; }

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(4, 38, 27, 0.14);
    border: 1px solid rgba(4, 38, 27, 0.28);
    color: #04261b;
    border-radius: 999px;
    padding: 5px 12px;
    font-size: 0.78rem;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.15s ease;
  }
  button:hover { background: rgba(4, 38, 27, 0.26); }
`;

export default function DemoBanner() {
  const handleExit = () => {
    demoService.exitDemo();
    window.location.replace('/');
  };

  return (
    <Pill>
      <span className="msg">
        <FiInfo size={15} />
        Modo demonstração — dados fictícios.
      </span>
      <button onClick={handleExit}>
        <FiLogOut size={13} />
        Sair da demo
      </button>
    </Pill>
  );
}
